// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-arrow:hover .arrow[data-v-39c5b902] {\n  -webkit-transform: translateX(5px) rotate(45deg);\n          transform: translateX(5px) rotate(45deg);\n  border-color: #000;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
